// Author thq
// Date 2021-12-21 11:31:25

import * as model from "@/model/em/accident/EmAcctHandleRecordAhrModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmAcctHandleRecordAhr(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_ACCIDENT_URL,
    })
    .buildStore()
